import { useState } from 'react';
import { Box, Skeleton, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { usePagination } from '@frontend/features/common/components/Table';

import { TableActions, ToggleActions } from '../../features/workflows/components/TableActions';
import { WorkflowsTable } from '../../features/workflows/components/Table';
import { SearchInput } from '../../features/common/components/SearchInput/SearchInput';
import { useGetWorkflowsByAgency } from '@frontend/features/workflows/queries';
import { WorkflowModal } from '@frontend/features/workflows/components/WorkflowModal';
import { ListLayout } from '@frontend/features/common/components/ListLayout';
import { useParams } from 'react-router-dom';
import { useDebouncedState } from '@frontend/features/common/hooks/useDebouncedState';

export const WorkflowsList = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { id } = useParams();
  const [search, setSearch] = useDebouncedState('', 300);
  const pagination = usePagination();

  const { data, isLoading } = useGetWorkflowsByAgency({
    pageSize: pagination.rowsPerPage,
    currentPage: pagination.page,
    search: search,
    agencyId: id,
  });

  const [action, setAction] = useState<ToggleActions | null>(null);

  const handleOnActionChange = (action: ToggleActions | null) => {
    setAction(action);
  };

  const handleOnSearch = (value: string) => {
    setSearch(value);
  };
  // TODO: fix this when implementing pagination
  const itemsCount = data?.items.length ?? 0;

  return (
    <ListLayout padding={0} title={t('workflows.title')} subtitle={t('workflows.subtitle')}>
      <Box display="flex" alignItems="center" gap={theme.spacing(3)} marginBottom={theme.spacing(3)}>
        <Typography
          variant="subtitle1"
          align="left"
          color={theme.palette.text.primary}
          sx={{
            flexGrow: 1,
          }}
        >
          {itemsCount} {t('workflows.results')}
        </Typography>
        <SearchInput placeholder={t('workflows.search')} onSearch={handleOnSearch} />
        <TableActions onActionChange={handleOnActionChange} action={action} />
      </Box>
      {id && <WorkflowModal agencyId={id} open={action === ToggleActions.Add} onClose={() => setAction(null)} />}
      <WorkflowsTable data={data?.items} pagination={pagination} />

      {isLoading && <Skeleton height={theme.spacing(10)} variant="rounded" animation="wave" />}
    </ListLayout>
  );
};
